// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file auth.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { User, UserJson } from "./user_pb";
import { file_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file auth.proto.
 */
export const file_auth: GenFile = /*@__PURE__*/
  fileDesc("CgphdXRoLnByb3RvEglyYWNjb29uYWkiLgoORmNtVG9rZW5VcGRhdGUSHAoJZmNtX3Rva2VuGAEgAigJUglmY21fdG9rZW4ilQEKDEF1dGhSZXNwb25zZRIiCgxhY2Nlc3NfdG9rZW4YASACKAlSDGFjY2Vzc190b2tlbhIeCgp0b2tlbl90eXBlGAIgAigJUgp0b2tlbl90eXBlEhsKAm1lGAMgAigLMg8ucmFjY29vbmFpLlVzZXISJAoNcmVmcmVzaF90b2tlbhgEIAEoCVINcmVmcmVzaF90b2tlbiI7ChNSZWZyZXNoVG9rZW5SZXF1ZXN0EiQKDXJlZnJlc2hfdG9rZW4YASACKAlSDXJlZnJlc2hfdG9rZW4iQQoJT1RQQ3JlYXRlEhgKB3VzZXJfaWQYASACKARSB3VzZXJfaWQSGgoIb3RwX2NvZGUYAiACKARSCG90cF9jb2RlInkKCk9UUFJlcXVlc3QSIgoMcGhvbmVfbnVtYmVyGAEgASgJUgxwaG9uZV9udW1iZXISDQoFZW1haWwYAiABKAkSDAoEbGFuZxgDIAIoCRIqChBwcmVmZXJyZWRfbWV0aG9kGAQgAigJUhBwcmVmZXJyZWRfbWV0aG9kIkIKD0xvZ2luT1RQUmVxdWVzdBIiCgxwaG9uZV9udW1iZXIYASACKAlSDHBob25lX251bWJlchILCgNvdHAYAiACKAQiUAoKTG9naW5Ub2tlbhIiCgxhY2Nlc3NfdG9rZW4YASACKAlSDGFjY2Vzc190b2tlbhIeCgp0b2tlbl90eXBlGAIgAigJUgp0b2tlbl90eXBlIogBChNQYXNzd29yZFJlc2V0VmlhT3RwEg0KBWVtYWlsGAEgASgJEiIKDHBob25lX251bWJlchgCIAEoCVIMcGhvbmVfbnVtYmVyEhoKCG90cF9jb2RlGAMgAigEUghvdHBfY29kZRIiCgxuZXdfcGFzc3dvcmQYBCACKAlSDG5ld19wYXNzd29yZCJxCg1QYXNzd29yZFJlc2V0EhgKB3VzZXJfaWQYASACKARSB3VzZXJfaWQSIgoMb2xkX3Bhc3N3b3JkGAIgAigJUgxvbGRfcGFzc3dvcmQSIgoMbmV3X3Bhc3N3b3JkGAMgAigJUgxuZXdfcGFzc3dvcmQiMgoMTG9naW5SZXF1ZXN0EhAKCHVzZXJuYW1lGAEgAigJEhAKCHBhc3N3b3JkGAIgAigJIloKCk1lUmVzcG9uc2USHQoEdXNlchgBIAIoCzIPLnJhY2Nvb25haS5Vc2VyEi0KDG9yZ2FuaXphdGlvbhgCIAEoCzIXLnJhY2Nvb25haS5Pcmdhbml6YXRpb24ibgoMVG9rZW5SZXF1ZXN0EhgKB3VzZXJfaWQYASABKARSB3VzZXJfaWQSRAoPZXhwaXJhdGlvbl9kYXRlGAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIPZXhwaXJhdGlvbl9kYXRlQgZaBC4vcGI", [file_google_protobuf_timestamp, file_organization, file_user]);

/**
 * @generated from message raccoonai.FcmTokenUpdate
 */
export type FcmTokenUpdate = Message<"raccoonai.FcmTokenUpdate"> & {
  /**
   * empty unsubscribes
   *
   * @generated from field: required string fcm_token = 1 [json_name = "fcm_token"];
   */
  fcmToken: string;
};

/**
 * @generated from message raccoonai.FcmTokenUpdate
 */
export type FcmTokenUpdateJson = {
  /**
   * empty unsubscribes
   *
   * @generated from field: required string fcm_token = 1 [json_name = "fcm_token"];
   */
  fcm_token?: string;
};

/**
 * Describes the message raccoonai.FcmTokenUpdate.
 * Use `create(FcmTokenUpdateSchema)` to create a new message.
 */
export const FcmTokenUpdateSchema: GenMessage<FcmTokenUpdate, {jsonType: FcmTokenUpdateJson}> = /*@__PURE__*/
  messageDesc(file_auth, 0);

/**
 * @generated from message raccoonai.AuthResponse
 */
export type AuthResponse = Message<"raccoonai.AuthResponse"> & {
  /**
   * @generated from field: required string access_token = 1 [json_name = "access_token"];
   */
  accessToken: string;

  /**
   * @generated from field: required string token_type = 2 [json_name = "token_type"];
   */
  tokenType: string;

  /**
   * User information
   *
   * @generated from field: required raccoonai.User me = 3;
   */
  me?: User;

  /**
   * @generated from field: optional string refresh_token = 4 [json_name = "refresh_token"];
   */
  refreshToken: string;
};

/**
 * @generated from message raccoonai.AuthResponse
 */
export type AuthResponseJson = {
  /**
   * @generated from field: required string access_token = 1 [json_name = "access_token"];
   */
  access_token?: string;

  /**
   * @generated from field: required string token_type = 2 [json_name = "token_type"];
   */
  token_type?: string;

  /**
   * User information
   *
   * @generated from field: required raccoonai.User me = 3;
   */
  me?: UserJson;

  /**
   * @generated from field: optional string refresh_token = 4 [json_name = "refresh_token"];
   */
  refresh_token?: string;
};

/**
 * Describes the message raccoonai.AuthResponse.
 * Use `create(AuthResponseSchema)` to create a new message.
 */
export const AuthResponseSchema: GenMessage<AuthResponse, {jsonType: AuthResponseJson}> = /*@__PURE__*/
  messageDesc(file_auth, 1);

/**
 * @generated from message raccoonai.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"raccoonai.RefreshTokenRequest"> & {
  /**
   * @generated from field: required string refresh_token = 1 [json_name = "refresh_token"];
   */
  refreshToken: string;
};

/**
 * @generated from message raccoonai.RefreshTokenRequest
 */
export type RefreshTokenRequestJson = {
  /**
   * @generated from field: required string refresh_token = 1 [json_name = "refresh_token"];
   */
  refresh_token?: string;
};

/**
 * Describes the message raccoonai.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest, {jsonType: RefreshTokenRequestJson}> = /*@__PURE__*/
  messageDesc(file_auth, 2);

/**
 * Not used in messaging. To be deprecated.
 *
 * @generated from message raccoonai.OTPCreate
 */
export type OTPCreate = Message<"raccoonai.OTPCreate"> & {
  /**
   * @generated from field: required uint64 user_id = 1 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: required uint64 otp_code = 2 [json_name = "otp_code"];
   */
  otpCode: bigint;
};

/**
 * Not used in messaging. To be deprecated.
 *
 * @generated from message raccoonai.OTPCreate
 */
export type OTPCreateJson = {
  /**
   * @generated from field: required uint64 user_id = 1 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: required uint64 otp_code = 2 [json_name = "otp_code"];
   */
  otp_code?: string;
};

/**
 * Describes the message raccoonai.OTPCreate.
 * Use `create(OTPCreateSchema)` to create a new message.
 */
export const OTPCreateSchema: GenMessage<OTPCreate, {jsonType: OTPCreateJson}> = /*@__PURE__*/
  messageDesc(file_auth, 3);

/**
 * @generated from message raccoonai.OTPRequest
 */
export type OTPRequest = Message<"raccoonai.OTPRequest"> & {
  /**
   * @generated from field: optional string phone_number = 1 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: optional string email = 2;
   */
  email: string;

  /**
   * @generated from field: required string lang = 3;
   */
  lang: string;

  /**
   * "whatsapp" or "email"
   *
   * @generated from field: required string preferred_method = 4 [json_name = "preferred_method"];
   */
  preferredMethod: string;
};

/**
 * @generated from message raccoonai.OTPRequest
 */
export type OTPRequestJson = {
  /**
   * @generated from field: optional string phone_number = 1 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: optional string email = 2;
   */
  email?: string;

  /**
   * @generated from field: required string lang = 3;
   */
  lang?: string;

  /**
   * "whatsapp" or "email"
   *
   * @generated from field: required string preferred_method = 4 [json_name = "preferred_method"];
   */
  preferred_method?: string;
};

/**
 * Describes the message raccoonai.OTPRequest.
 * Use `create(OTPRequestSchema)` to create a new message.
 */
export const OTPRequestSchema: GenMessage<OTPRequest, {jsonType: OTPRequestJson}> = /*@__PURE__*/
  messageDesc(file_auth, 4);

/**
 * @generated from message raccoonai.LoginOTPRequest
 */
export type LoginOTPRequest = Message<"raccoonai.LoginOTPRequest"> & {
  /**
   * @generated from field: required string phone_number = 1 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: required uint64 otp = 2;
   */
  otp: bigint;
};

/**
 * @generated from message raccoonai.LoginOTPRequest
 */
export type LoginOTPRequestJson = {
  /**
   * @generated from field: required string phone_number = 1 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: required uint64 otp = 2;
   */
  otp?: string;
};

/**
 * Describes the message raccoonai.LoginOTPRequest.
 * Use `create(LoginOTPRequestSchema)` to create a new message.
 */
export const LoginOTPRequestSchema: GenMessage<LoginOTPRequest, {jsonType: LoginOTPRequestJson}> = /*@__PURE__*/
  messageDesc(file_auth, 5);

/**
 * @generated from message raccoonai.LoginToken
 */
export type LoginToken = Message<"raccoonai.LoginToken"> & {
  /**
   * @generated from field: required string access_token = 1 [json_name = "access_token"];
   */
  accessToken: string;

  /**
   * @generated from field: required string token_type = 2 [json_name = "token_type"];
   */
  tokenType: string;
};

/**
 * @generated from message raccoonai.LoginToken
 */
export type LoginTokenJson = {
  /**
   * @generated from field: required string access_token = 1 [json_name = "access_token"];
   */
  access_token?: string;

  /**
   * @generated from field: required string token_type = 2 [json_name = "token_type"];
   */
  token_type?: string;
};

/**
 * Describes the message raccoonai.LoginToken.
 * Use `create(LoginTokenSchema)` to create a new message.
 */
export const LoginTokenSchema: GenMessage<LoginToken, {jsonType: LoginTokenJson}> = /*@__PURE__*/
  messageDesc(file_auth, 6);

/**
 * @generated from message raccoonai.PasswordResetViaOtp
 */
export type PasswordResetViaOtp = Message<"raccoonai.PasswordResetViaOtp"> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email: string;

  /**
   * @generated from field: optional string phone_number = 2 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: required uint64 otp_code = 3 [json_name = "otp_code"];
   */
  otpCode: bigint;

  /**
   * @generated from field: required string new_password = 4 [json_name = "new_password"];
   */
  newPassword: string;
};

/**
 * @generated from message raccoonai.PasswordResetViaOtp
 */
export type PasswordResetViaOtpJson = {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string phone_number = 2 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: required uint64 otp_code = 3 [json_name = "otp_code"];
   */
  otp_code?: string;

  /**
   * @generated from field: required string new_password = 4 [json_name = "new_password"];
   */
  new_password?: string;
};

/**
 * Describes the message raccoonai.PasswordResetViaOtp.
 * Use `create(PasswordResetViaOtpSchema)` to create a new message.
 */
export const PasswordResetViaOtpSchema: GenMessage<PasswordResetViaOtp, {jsonType: PasswordResetViaOtpJson}> = /*@__PURE__*/
  messageDesc(file_auth, 7);

/**
 * @generated from message raccoonai.PasswordReset
 */
export type PasswordReset = Message<"raccoonai.PasswordReset"> & {
  /**
   * @generated from field: required uint64 user_id = 1 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: required string old_password = 2 [json_name = "old_password"];
   */
  oldPassword: string;

  /**
   * @generated from field: required string new_password = 3 [json_name = "new_password"];
   */
  newPassword: string;
};

/**
 * @generated from message raccoonai.PasswordReset
 */
export type PasswordResetJson = {
  /**
   * @generated from field: required uint64 user_id = 1 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: required string old_password = 2 [json_name = "old_password"];
   */
  old_password?: string;

  /**
   * @generated from field: required string new_password = 3 [json_name = "new_password"];
   */
  new_password?: string;
};

/**
 * Describes the message raccoonai.PasswordReset.
 * Use `create(PasswordResetSchema)` to create a new message.
 */
export const PasswordResetSchema: GenMessage<PasswordReset, {jsonType: PasswordResetJson}> = /*@__PURE__*/
  messageDesc(file_auth, 8);

/**
 * @generated from message raccoonai.LoginRequest
 */
export type LoginRequest = Message<"raccoonai.LoginRequest"> & {
  /**
   * @generated from field: required string username = 1;
   */
  username: string;

  /**
   * @generated from field: required string password = 2;
   */
  password: string;
};

/**
 * @generated from message raccoonai.LoginRequest
 */
export type LoginRequestJson = {
  /**
   * @generated from field: required string username = 1;
   */
  username?: string;

  /**
   * @generated from field: required string password = 2;
   */
  password?: string;
};

/**
 * Describes the message raccoonai.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest, {jsonType: LoginRequestJson}> = /*@__PURE__*/
  messageDesc(file_auth, 9);

/**
 * @generated from message raccoonai.MeResponse
 */
export type MeResponse = Message<"raccoonai.MeResponse"> & {
  /**
   * @generated from field: required raccoonai.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: optional raccoonai.Organization organization = 2;
   */
  organization?: Organization;
};

/**
 * @generated from message raccoonai.MeResponse
 */
export type MeResponseJson = {
  /**
   * @generated from field: required raccoonai.User user = 1;
   */
  user?: UserJson;

  /**
   * @generated from field: optional raccoonai.Organization organization = 2;
   */
  organization?: OrganizationJson;
};

/**
 * Describes the message raccoonai.MeResponse.
 * Use `create(MeResponseSchema)` to create a new message.
 */
export const MeResponseSchema: GenMessage<MeResponse, {jsonType: MeResponseJson}> = /*@__PURE__*/
  messageDesc(file_auth, 10);

/**
 * @generated from message raccoonai.TokenRequest
 */
export type TokenRequest = Message<"raccoonai.TokenRequest"> & {
  /**
   * @generated from field: optional uint64 user_id = 1 [json_name = "user_id"];
   */
  userId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 2 [json_name = "expiration_date"];
   */
  expirationDate?: Timestamp;
};

/**
 * @generated from message raccoonai.TokenRequest
 */
export type TokenRequestJson = {
  /**
   * @generated from field: optional uint64 user_id = 1 [json_name = "user_id"];
   */
  user_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expiration_date = 2 [json_name = "expiration_date"];
   */
  expiration_date?: TimestampJson;
};

/**
 * Describes the message raccoonai.TokenRequest.
 * Use `create(TokenRequestSchema)` to create a new message.
 */
export const TokenRequestSchema: GenMessage<TokenRequest, {jsonType: TokenRequestJson}> = /*@__PURE__*/
  messageDesc(file_auth, 11);

